export enum KeycloakRole {
  BACKOFFICE = 'backoffice',
  BACKOFFICE_REVIEWER_HYGIENE = 'backoffice_reviewer_hygiene',
  BACKOFFICE_ADMIN = 'backoffice_admin',
  BACKOFFICE_PLANNER = 'backoffice_planner',
  BACKOFFICE_SHIPPER = 'backoffice_shipper',
}
